import * as React from 'react';
import DatePicker, { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import Icon from '../Icon/Icon';
import { cn } from '../../utils';

type CalendarProps = {
  selected?: Date;
  minDate?: Date;
  maxDate?: Date;
  onChange?: (
    date: Date | undefined,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
  renderDayContents?: (day: number, date: Date) => React.ReactNode;
};

const Calendar = React.forwardRef<HTMLDivElement, CalendarProps>(
  ({ onChange, renderDayContents, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className='snap-ui-datepicker-wrapper'
        data-testid={props['data-testid']}
      >
        <DatePicker
          renderCustomHeader={(props) => <CustomDatePickerHeader {...props} />}
          inline
          disabledKeyboardNavigation
          renderDayContents={renderDayContents}
          onChange={onChange}
          {...props}
        />
      </div>
    );
  }
);

export default Calendar;

const CustomDatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <div className='sui-flex sui-justify-between sui-items-center sui-mb-1'>
    <button
      className={cn(
        prevMonthButtonDisabled
          ? 'sui-invisible'
          : 'sui-pt-1 hover:sui-text-action-background-hover'
      )}
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
      data-testid='snap-ui-datepicker-prev-month-button'
    >
      <Icon name='keyboard_arrow_left' />
    </button>
    <div className='react-datepicker__current-month'>{`${months[date.getMonth()]} ${date.getFullYear()}`}</div>
    <button
      className={cn(
        nextMonthButtonDisabled
          ? 'sui-invisible'
          : 'sui-pt-1 hover:sui-text-action-background-hover'
      )}
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
      data-testid='snap-ui-datepicker-next-month-button'
    >
      <Icon name='keyboard_arrow_right' />
    </button>
  </div>
);

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
